import React from 'react';
import PropTypes from 'prop-types';
import FooterScene from './FooterScene';
import {
  FooterWrapperStyled,
  FooterContentWrapStyled,
  FooterContainerStyled,
} from './styles/FooterStyled';

import { ReactComponent as WomLogo } from '../../../images/logowom.svg';

const Footer = ({ copyrightYear }) => {
  const year = copyrightYear || new Date().getFullYear();

  return (
    <FooterWrapperStyled>
      <FooterScene />
      <FooterContentWrapStyled>
        <FooterContainerStyled>
          <span>
            <WomLogo />
          </span>
          <p>{`${year} © Todos los derechos reservados`}</p>
        </FooterContainerStyled>
      </FooterContentWrapStyled>
    </FooterWrapperStyled>
  );
};

Footer.propTypes = {
  copyrightYear: PropTypes.string,
};

Footer.defaultProps = {
  copyrightYear: null,
};

export default Footer;
